import { render, staticRenderFns } from "./preRegisterDone.vue?vue&type=template&id=37d324fa&scoped=true&"
import script from "./preRegisterDone.vue?vue&type=script&lang=js&"
export * from "./preRegisterDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d324fa",
  null
  
)

export default component.exports